const endpoint = '/cart-service/api/external/negotiations';

export const negotiationsContext = {
  get: `${endpoint}/`,
  statistics: `${endpoint}/statistics`,
  getById: `${endpoint}/{id}`,
  updateSellerPrice: `${endpoint}/{id}`,
  changeDecision: `${endpoint}/{id}/decision`,
};
